const errCode = {
  '2004' : 'Wrong password' ,  //密码错误
  '2015' : 'Account does not exist' , //账户不存在
  '140001':'Product has expired' ,//产品已失效
  '140009':'The coupon code is invalid.', //"优惠码已失效",
  '140010':'You can not use the code on your own purchase', //"用户不能使用自己分享的优惠码",
  '140011': 'Some products have been removed.',//"订单中存在已下架的商品",
  '140012': 'Some products have been removed.', //"订单中部分商品的联盟状态发生了改变",
  '140013':'The prices of some products have changed.', //"订单中部分商品金额发生了变化",
  '140014':'Some products are out of stock. ' ,  // 订单中部分商品无库存
  '140015':'Coupon cannot be reused.' ,   //优惠劵不能重复使用
  '150002' : ' The coupon code is invalid.' , //折扣码失效
}
export default errCode
